import { AuthGuard } from './auth.guard';
import { CustomerGuard } from './customer.guard';
import { OnboardingGuard } from './onboarding.guard';

export * from './auth.guard';
export * from './customer.guard';
export * from './onboarding.guard';
export { downtimeGuard } from './downtime.guard';
export { consentGuard } from './consent.guard';

export const GENERAL_GUARDS = [AuthGuard, CustomerGuard, OnboardingGuard];
